export default __webpack_public_path__ + "static/media/manage_picktime_icon.278893e9.svg";